import React from 'react';

const InternshipTimeLine = () => {
    return (
        <div className=''>
            <div className='py-6 '>
                <h1 className="text-2xl text-primary font-normal">
                    Internship 


                </h1>
                <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">I have done more then 4+ internship  as well try to make expert developer, problem solver.</h1>

                <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-6">
                    <div className="">
                        <ol class="relative border-l border-gray-200 dark:border-gray-700">
                            <li class="mb-10 ml-4">
                                <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl text-xl font-normal">Web Development Student</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500  text-xl font-normal py-1">Programming-hero.com, Bangladesh</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500   font-normal ">2021-2022</h1>

                                <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, a nam illo culpa fuga fugit optio doloremque quae veritatis cum tempore hic nisi temporibus cupiditate quasi minima praesentium eius illum error labore assumenda quod voluptatibus. Voluptatum quia perferendis dolorem tempore maxime accusantium doloribus eius. Vel harum minima debitis temporibus vero.</p>

                            </li>
                            <li class="mb-10 ml-4">
                                <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl text-xl font-normal">Web Development Intern</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500  text-xl font-normal py-1">Programming-hero.com,Bangladesh</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500   font-normal ">Aug2022-Nov2022</h1>

                                <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, a nam illo culpa fuga fugit optio doloremque quae veritatis cum tempore hic nisi temporibus cupiditate quasi minima praesentium eius illum error labore assumenda quod voluptatibus. Voluptatum quia perferendis dolorem tempore maxime accusantium doloribus eius. Vel harum minima debitis temporibus vero.</p>

                            </li>

                           


                        </ol>
                    </div>
                    <div className="">
                        <ol class="relative border-l border-gray-200 dark:border-gray-700">
                            <li class="mb-10 ml-4">
                                <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl text-xl font-normal">Web Development Intern</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500  text-xl font-normal py-1">BVUR Innovations ,India</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500   font-normal ">Nov2023-Feb2022</h1>

                                <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, a nam illo culpa fuga fugit optio doloremque quae veritatis cum tempore hic nisi temporibus cupiditate quasi minima praesentium eius illum error labore assumenda quod voluptatibus. Voluptatum quia perferendis dolorem tempore maxime accusantium doloribus eius. Vel harum minima debitis temporibus vero.</p>

                            </li>
                            <li class="mb-10 ml-4">
                                <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl text-xl font-normal">Web Developer</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500  text-xl font-normal py-1">Suidha Foundation ,India</h1>
                                <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500   font-normal ">Oct2022-Dec2022</h1>

                                <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, a nam illo culpa fuga fugit optio doloremque quae veritatis cum tempore hic nisi temporibus cupiditate quasi minima praesentium eius illum error labore assumenda quod voluptatibus. Voluptatum quia perferendis dolorem tempore maxime accusantium doloribus eius. Vel harum minima debitis temporibus vero.</p>

                            </li>

                         
                         


                        </ol>
                    </div>

                </div>


            </div>
        </div>
    );
};

export default InternshipTimeLine;